/**
 *
 * Publications Page
 *
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@pearsontechnology/aero-components';

import { PageContent } from 'components/PageStyles';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import PlaceholderList from 'components/PlaceholderList';
import EmptyPageBuilder from 'components/EmptyPage';
import classEmptyDarkImage from 'images/class-empty-dark.png';
import classEmptyLightImage from 'images/class-empty-light.png';
import messages from './messages';
import PublicationList from '../PublicationList';
import { setPublicationsSearch } from 'Workspace/Publications/store/actions';

import {
  FeatureContainer,
  AddButton,
  EmptyPublication,
} from './styles';
import PublicationSearch from '../PublicationSearch';
import { dispatch } from 'pluginServices/store';

const EmptyPage = EmptyPageBuilder.build({
  lightBackgroundImage: classEmptyLightImage,
  darkBackgroundImage: classEmptyDarkImage,
});

/**
 * Renders Publication Page Content
 */
const PublicationPageContent = ({ loading, publicationList, showPublicationSelectorModal }) => {
  // clearing the publicationsSearch state, when we navigate to another page
  useEffect(() => () => dispatch(setPublicationsSearch('')), []);

  const PublicationFeature = () => (
    <FeatureContainer>
      <PublicationSearch />
      <AddButton>
        <Button primary onClick={showPublicationSelectorModal}>
          {intl.formatMessage(messages.ADD)}
        </Button>
      </AddButton>
    </FeatureContainer>
  );

  if (loading) {
    return (
      <PageContent>
        <PublicationFeature />
        <PlaceholderList />
      </PageContent>
    );
  }

  if (publicationList?.length) {
    return (
      <PageContent>
        <PublicationFeature />
        <PublicationList />
      </PageContent>
    );
  }

  return (
    <EmptyPublication>
      <EmptyPage
        description={intl.formatMessage(messages.create)}
        buttonText={intl.formatMessage(messages.getStarted)}
        buttonCallback={showPublicationSelectorModal}
      />
    </EmptyPublication>
  );
};

PublicationPageContent.propTypes = {
  loading: PropTypes.bool,
  showPublicationSelectorModal: PropTypes.func,
  publicationList: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default PublicationPageContent;
